export default function(value) {
	const isNegative = Math.sign(value);
	return isNegative === -1 ? 'totalNegative' : 'total';
}
